"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _dlgNewLineBudgetComp = _interopRequireDefault(require("./dlgNewLineBudgetComp"));

var _moment = _interopRequireDefault(require("moment"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'LotDetailBudgetsComp',
  props: ['idLot'],
  components: {
    dlgNewLineBudgetComp: _dlgNewLineBudgetComp.default
  },
  data: function data() {
    return {
      CONST: CONST,
      dlgNewLineVisible: false,
      refresh: 0,
      lotsDetail: [],
      calculs: [],
      totaux: [],
      modeEdit: false
    };
  },
  computed: {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    },
    maxOrdre: function maxOrdre() {
      var max = 0;

      if (this.lotsDetail.length > 0) {
        max = Math.max.apply(Math, this.$store.getters.affaire.lotsDetail.map(function (x) {
          return x.ordre;
        }));
      }

      return max + 1;
    },
    nbCol: function nbCol() {
      return this.affaire.nbColBudgetComp;
    }
  },
  created: function created() {
    var _this = this;

    this.$watch('$root.modeEdit', function (newValue) {
      if (newValue === false) {
        _this.modeEdit = false;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    _eventBus.EventBus.$on('REFRESH', function () {
      _this2.lotsDetail = _this2.$store.getters.affaire.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && [CONST.LOT_DETAIL.TYPE_LIGNE.BUDGET_COMP].includes(x.type_lot_detail);
      });
      _this2.calculs = _this2.$store.getters.affaire.calculs.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && [CONST.LOT_DETAIL.TYPE_LIGNE.BUDGET_COMP].includes(x.type_lot_detail);
      });
      _this2.totaux = _this2.$store.getters.affaire.calculs.lots.filter(function (x) {
        return x.id === _this2.idLot;
      });
    });

    _eventBus.EventBus.$on('BUDGETCOMP_NEW', function () {
      _this2.modeEdit = true;
    });

    _eventBus.EventBus.$on('BUDGETCOMP_CANCEL', function () {
      _this2.modeEdit = false;

      _this2.onCancelBugetComp();
    });

    _eventBus.EventBus.$on('BUDGETCOMP_SAVE', function () {
      _this2.modeEdit = false;

      _this2.onSaveBudgetComp(); // enregistre les montants et fige la derniere colonne des budgets complementaires

    });

    this.refresh++;
  },
  beforeDestroy: function beforeDestroy() {
    _eventBus.EventBus.$off('REFRESH');

    _eventBus.EventBus.$off('BUDGETCOMP_NEW');

    _eventBus.EventBus.$off('BUDGETCOMP_CANCEL');

    _eventBus.EventBus.$off('BUDGETCOMP_SAVE');
  },
  methods: {
    gestMens: function gestMens(numCol) {
      if (this.affaire.calculs.affaire) {
        return this.affaire.calculs.affaire.colonneBudgetComp[numCol].periode_gestmens;
      }
    },
    dateCol: function dateCol(numCol) {
      if (this.affaire.calculs.affaire) {
        // return this.affaire.calculs.affaire.dateColonneBudgetComp[numCol]
        return this.affaire.calculs.affaire.colonneBudgetComp[numCol].date_creation;
      }
    },
    mtTotalLotColonneBudgetComp: function mtTotalLotColonneBudgetComp(index, column) {
      return this.totaux[index] && this.totaux[index].mtTotalLotColonneBudgetComp[column] ? this.totaux[index].mtTotalLotColonneBudgetComp[column] : '';
    },
    mtTotalLotLigneBudgetComp: function mtTotalLotLigneBudgetComp(index) {
      return this.totaux[index] ? this.totaux[index].mtTotalLotLigneBudgetComp : '';
    },
    canAddBudgetComp: function canAddBudgetComp(scope) {
      return scope.row.validation === 1 || scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.BUDGET_COMP;
    },
    handleInput: function handleInput(scope, action) {
      var data = {
        id_lot_detail: scope.row.id,
        num_colonne: this.nbCol + 1,
        mt_budget_complementaire: scope.row.mt_budget_complementaire,
        date_creation: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss'),
        periode_gestmens: this.affaire.YYYYMM ? this.affaire.YYYYMM : ''
      };
      this.$store.dispatch('affaire/setBudgetComp', data).then(function () {
        if (action === 'refresh_calcul') {
          _eventBus.EventBus.$emit('REFRESH_CALCULS');
        }
      });
    },
    onCancelBugetComp: function onCancelBugetComp() {
      // pour vider le champ de saisie et ne pas avoir l'ancienne valeur quand on fera "Nouveau budget complémentaire"
      this.lotsDetail.forEach(function (row) {
        row.mt_budget_complementaire = '';
      });
      this.$store.commit('affaire/DEL_ALLBUDGETCOMP_BY_NUMCOL', this.nbCol + 1);

      _eventBus.EventBus.$emit('REFRESH_CALCULS');
    },
    onSaveBudgetComp: function onSaveBudgetComp() {
      var _this3 = this;

      this.lotsDetail.forEach( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(row) {
          var mt, data;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  mt = row.mt_budget_complementaire || '';

                  if (!(mt !== '')) {
                    _context.next = 6;
                    break;
                  }

                  data = {
                    id_lot_detail: row.id,
                    num_colonne: _this3.nbCol + 1,
                    mt_budget_complementaire: row.mt_budget_complementaire,
                    date_creation: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss'),
                    periode_gestmens: _this3.affaire.YYYYMM ? _this3.affaire.YYYYMM : ''
                  };
                  _context.next = 5;
                  return _this3.$store.dispatch('affaire/insertBudgetComp', data);

                case 5:
                  row.mt_budget_complementaire = ''; // pour vider le champ de saisie du montant

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      this.$root.modeEdit = false;

      _eventBus.EventBus.$emit('REFRESH_CALCULS');
    }
  }
};
exports.default = _default;